/* eslint-disable react/no-array-index-key */
import { type ProductListMenuItemViewModel, MenuItemElementViewModelDiscriminator } from 'autogen/swagger/all';
import Menu from 'components/generic/menu';
import { memo } from 'react';

import CategorySideSubMenu from './CategorySideSubMenu';

export function ItemRenderer({ model }: { model: ProductListMenuItemViewModel }) {
    return MenuItemElementViewModelDiscriminator(
        model.itemElement,
        ({ text, cssClass }) => <Menu.Item className={cssClass}>{text}</Menu.Item>,
        ({ text, link: action }) => <Menu.Item.Action action={action}>{text}</Menu.Item.Action>,
        () => null
    );
}

const MenuItemsRenderer = ({ menuItems }: { menuItems: ProductListMenuItemViewModel[] }) => (
    <>
        {menuItems.map((item, index) => {
            if (item.children.length) {
                return <CategorySideSubMenu key={index} model={item} />;
            }

            return <ItemRenderer key={index} model={item} />;
        })}
    </>
);

export default memo(MenuItemsRenderer);
